import {
  webSocketGateway,
  websocketSchemas,
} from "@smart/intake-resources-basic";
import { useWebsocket } from "@smart/itops-hooks-dom";

export const intakeWebsocket = useWebsocket(
  webSocketGateway.prefix,
  webSocketGateway.lambdaKeys,
  websocketSchemas,
);
